import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { CommonService } from 'src/app/_services/common.service';
import { AlertService } from 'src/app/_helpers/alert.service';
import { AuthService } from 'src/app/_services/auth.service';
import { setDoc } from 'firebase/firestore';
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  getDoc,
} from 'firebase/firestore';
import { doc, onSnapshot, orderBy } from 'firebase/firestore';
import { IUser } from '../_interfaces/IUser.types';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
  user!: IUser;
  hidePassword: boolean = true;
  showLoader: boolean = false;

  @ViewChild('loginNgForm') loginNgForm!: NgForm;
  loginForm: FormGroup = this._formBuilder.group({
    email : ['', [
      Validators.required,
      Validators.email,
      Validators.pattern(this._commonService.emailRegex)
    ]],
    password : ['', [
      Validators.required
    ]],
    rememberMe : [false],
  });

  constructor(
    private _title: Title,
    private _formBuilder: FormBuilder,
    private _authService: AuthService,
    private _alertService: AlertService,
    private _commonService: CommonService
  ) {
    this._title.setTitle('Vendor: Login');
  }

  ngOnInit(): void {
  }

  login() {
    // Return if the form is invalid
    if (this.loginForm?.invalid) {
      return;
    }

    this.showLoader = true;
    this._authService.signIn(this.loginForm.value).subscribe({
      next: (response: any) => {
        const { isSuccess, message } = response;
        if(isSuccess) {
          this._commonService.userDefaultRoute();
          this.user = response.data.user;
            this.getChatUser();
        } else {
          this._alertService.show_alert(message, '', 'error');
        }
        this.showLoader = false;
      },
      error: (errorResponse) => {
        this.showLoader = false;
        this._alertService.show_alert(errorResponse?.message, '', 'error');
      }
    });
  }

  async getChatUser() {
    const db = getFirestore();
    const citiesRef = collection(db, 'users');
    setDoc(
      doc(citiesRef, this.user._id),
      {
        status: 'online',
      },
      { merge: true }
    );
  }

}
